import { render, staticRenderFns } from "./Reaction.vue?vue&type=template&id=3886d382"
import script from "./Reaction.vue?vue&type=script&lang=js"
export * from "./Reaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports